export default "__VITE_ASSET__DVfd15k1__"